import { useState, useCallback } from 'react';
import { message } from 'antd';
import { p1308Api, ReportFilter, ReportData } from '../../../services/p1308Api';

export interface P1308ReportState {
  loading: boolean;
  reportData: ReportData | null;
  queried: boolean;
  noData: boolean;
}

export interface P1308ReportActions {
  runQuery: (filter: ReportFilter) => Promise<void>;
  reset: () => void;
}

export function useP1308Report(): P1308ReportState & P1308ReportActions {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState<ReportData | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (filter: ReportFilter) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await p1308Api.query(filter);
      if (resp.data && resp.data.items.length > 0) {
        setReportData(resp.data);
        setNoData(false);
      } else {
        setReportData(null);
        setNoData(true);
        message.info(resp.message || '查無符合條件的幣別資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setReportData(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, reportData, queried, noData, runQuery, reset };
}
